<template>
  <transition name="pop-message-slide">
    <!-- @mouseenter="pauseTimer"
      @mouseleave="resumeTimer" -->
    <div
      v-if="visible"
      class="pop-message"
    >
      <div class="pop-message-inner">
        <span class="pop-message-icon">
          <i :class="iconClass" />
        </span>
        <span class="pop-message-content">{{ message }}</span>
        <!-- 关闭按钮 -->
        <span
          v-if="showClose"
          class="pop-message-close"
          @click="close"
        >
          <i class="el-icon-close" />
        </span>
      </div>
      <!-- <div class="pop-progress-bar" :style="{ width: progress + '%' }"></div> -->
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PopMessage',
  props: {
    message: String,
    type: {
      type: String,
      default: 'info' // success, error, warning, info
    },
    duration: {
      type: Number,
      default: 3000
    },
    showClose: {
      type: Boolean,
      default: false
    },
    onClose: Function,
    iconClassName: {
      type: String,
      default: 'ai-info'
    }
  },
  data() {
    return {
      visible: false,
      progress: 100,
      interval: null
    }
  },
  computed: {
    iconClass() {
      switch (this.type) {
        case 'success': return 'aifont ai-success'
        case 'error': return 'aifont ai-error'
        case 'warning': return 'aifont ai-warning'
        case 'info': return 'aifont ai-info'
        default: return 'aifont ' + this.iconClassName
      }
    }
  },
  mounted() {
    this.showMessage()
  },
  methods: {
    showMessage() {
      this.visible = true
      const step = 100 / (this.duration / 50)
      this.interval = setInterval(() => {
        this.progress -= step
        if (this.progress <= 0) this.close()
      }, 50)
    },
    pauseTimer() {
      clearInterval(this.interval)
    },
    resumeTimer() {
      this.showMessage()
    },
    close() {
      this.visible = false
      clearInterval(this.interval)
      setTimeout(() => {
        this.$el && this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
        this.$destroy()
      }, 300)
      // ⭐ 这里执行回调
      if (this.onClose && typeof this.onClose === 'function') {
        try {
          this.onClose()
        } catch (e) {
          console.error('[popMessage] onClose error:', e)
        }
      }
    }
  }
}
</script>

<style scoped>
.pop-message {
  min-width: 300px;
  max-width: 400px;
  padding: 12px 20px;
  margin-top: 10px;
  color: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.2);
  overflow: hidden;
  pointer-events: all;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background-color: var(--primary); /* 统一背景色 */
  text-align: left;
  position: relative;
}

/* 内部布局：图标 + 内容 */
.pop-message-inner {
  display: flex;
  align-items: center;
}

.pop-message-icon {
  margin-right: 10px;
  font-size: 18px;
  flex-shrink: 0;
  .ai-success {
    color: var(--success-color);
  }
  .ai-warning {
    color: var(--warning-color);
  }
  .ai-error {
    color: var(--error-color);
  }
  .ai-info {
    color: var(--primary);
  }
}

.pop-message-close {
  margin-left: 10px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(255,255,255,0.8);
  flex-shrink: 0;
}

.pop-message-close:hover {
  color: #fff;
}

.pop-message-content {
  flex: 1;
}

/* 进度条 */
.pop-progress-bar {
  height: 3px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  bottom: 0;
  left: 0;
  transition: width 0.05s linear;
}

/* 顶部居中滑入滑出动画 */
.pop-message-slide-enter-active, .pop-message-slide-leave-active {
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.pop-message-slide-enter {
  transform: translateY(-50%) scale(0.8);
  opacity: 0;
}
.pop-message-slide-enter-to {
  transform: translateY(0) scale(1);
  opacity: 1;
}
.pop-message-slide-leave {
  transform: translateY(0) scale(1);
  opacity: 1;
}
.pop-message-slide-leave-to {
  transform: translateY(-50%) scale(0.8);
  opacity: 0;
}

</style>
